"use client";

import { PAGE_SIZE } from "@faire/deprecated-retailer-visitor-shared/search/searchRequest";
import { SearchPageDataContextProvider } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageDataContext";
import { SearchPageFiltersDataContextProvider } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageFiltersDataContext";
import {
  useSearchPageFiltersQueryArgs,
  useSearchPageQueryArgs,
} from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/useSearchPageQueryArgs";
import { useQuery } from "@tanstack/react-query";
import { ReactNode, useMemo } from "react";

export const WithSearchPageUseQueryContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <SearchPageProductsUseQueryDataProvider>
      <SearchPageFiltersUseQueryDataProvider>
        {children}
      </SearchPageFiltersUseQueryDataProvider>
    </SearchPageProductsUseQueryDataProvider>
  );
};

const SearchPageProductsUseQueryDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { productsQueryArgs } = useSearchPageQueryArgs(PAGE_SIZE);

  const productsQuery = useQuery({
    queryKey: productsQueryArgs.key,
    queryFn: productsQueryArgs.fn,

    staleTime: productsQueryArgs.staleTime,
  });

  const data = useMemo(() => {
    return {
      productsData: {
        legacyResponse: productsQuery.data,
        legacyProductTokens: undefined,
      },
      loading: productsQuery.isFetching,
      isError: productsQuery.isError,
      error: productsQuery.error,
      dataUpdatedAt: productsQuery.dataUpdatedAt,
      rscPageLoadKey: "", // noOp
    };
  }, [
    productsQuery.data,
    productsQuery.dataUpdatedAt,
    productsQuery.error,
    productsQuery.isError,
    productsQuery.isFetching,
  ]);

  return (
    <SearchPageDataContextProvider searchPageData={data}>
      {children}
    </SearchPageDataContextProvider>
  );
};

const SearchPageFiltersUseQueryDataProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { filtersQueryArgs } = useSearchPageFiltersQueryArgs();

  const filtersQuery = useQuery({
    queryKey: filtersQueryArgs.key,
    queryFn: filtersQueryArgs.fn,
    staleTime: filtersQueryArgs.staleTime,
  });

  const data = useMemo(() => {
    return {
      legacyFiltersResponse: filtersQuery.data,
      loading: filtersQuery.isFetching,
      isError: filtersQuery.isError,
      error: filtersQuery.error,
    };
  }, [
    filtersQuery.data,
    filtersQuery.error,
    filtersQuery.isError,
    filtersQuery.isFetching,
  ]);

  return (
    <SearchPageFiltersDataContextProvider searchPageFiltersData={data}>
      {children}
    </SearchPageFiltersDataContextProvider>
  );
};
